/**
 * Главный экран приложения на этапе S1: что человеку открыто.
 *
 * Разделов на экране столько, сколько назначено его должности (D51), и
 * содержимого у них пока нет — этап S1 закрывает вход и видимость, а
 * справочник блюд приходит на S2. Поэтому раздел честно говорит, что в
 * нём появится и когда: пустая карточка без объяснения читается как
 * поломка.
 *
 * Экран **не решает, что показывать** — это решает сервер и присылает
 * готовый список. Логика видимости, повторённая в браузере, разошлась бы
 * с серверной в первом же исключении (владелец, смена должности), и
 * разошлась бы незаметно.
 */

import { Card, Empty } from '@shell/index';
import type { SectionView, StudyMe } from '../api';

/** Что появится в разделе и на каком этапе (§17 ТЗ сервиса). */
const STAGE_NOTE: Record<string, string> = {
  dishes: 'Карточки блюд с составом, аллергенами и подачей — этап S2.',
  tech_cards: 'Технологические карты дословно — этап S2.',
  bar: 'Барная карта и рецептуры — этап S2.',
  wine: 'Винная карта и сочетания — этап S2.',
  courses: 'Курсы, уроки и тесты — этап S4.',
  assistant: 'Ответы по внутренним регламентам со ссылкой на документ — этап S6.',
  mentor: 'Ваши показатели, разбор чека и тренировки — этапы S8–S11.',
};

export function Sections({ me }: { me: StudyMe }) {
  if (me.problem) {
    // Не пустой экран и не «ошибка»: человеку сказано, что происходит и к
    // кому идти. Формулировку присылает сервер — одну и ту же для бота и
    // для приложения (§7.2).
    return <Empty title="Пока показывать нечего" text={me.problem} />;
  }

  return (
    <>
      {me.sections.map((section: SectionView) => (
        <Card key={section.code} title={section.name}>
          <p className="faint">{STAGE_NOTE[section.code] ?? 'Раздел появится позже.'}</p>
        </Card>
      ))}
    </>
  );
}
